import { DarkTheme } from '@mercedes-benz/mui5-theme';
import HomeIcon from '@mui/icons-material/Home';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { SettingsPage } from '../features/settings';
import { VesselSalesHomePage } from '../features/vessel';
import { HomePage } from '../shared/ui/HomePage';

const AppConfig = {
  appName: 'Delivery Promise',
  sideBarWidth: 250,
  defaultTheme: DarkTheme,
  defaultRoute: 'home',
};

AppConfig.homeSubPages = [
  /*   {
      name: 'Vessel Journal',
      component: <VesselScheduleHomePage />,
      url: 'VesselScheduleHomePage',
      image: '/resources/Vessel_Tracking.jpg',
      product: 'Vessel',
      auth: ["LP_Admin"],
    }, */
  {
    name: 'Vessel Journal',
    component: <VesselSalesHomePage />,
    url: 'VesselSalesHomePage',
    image: '/resources/vessel_journal.png',
    product: 'Vessel',
    auth: [
      'LP_Admin',
      'LP_TLP',
      'LP_Management',
      'DP_Vessel_Journal_Port_Operator',
      'DP_Vessel_Journal_Market_User',
      'DP_Vessel_Journal_Key_User',
      'DP_Vessel_Journal_Shipping_Company',
    ],
  },
  /*   {
      name: 'Vessel Performance',
      component: <VesselPerformanceHomePage />,
      url: 'VesselPerformanceHomePage',
      image: '/resources/Vessel_Tracking.jpg',
      product: 'Vessel',
      auth: ["LP_Admin"],
    }, */
  {
    name: 'TLP',
    // component: <TLPHomePage />,
    url: 'https://tlp.supplier.mercedes-benz.com/',
    image: '/resources/TLP.jpg',
    product: 'Outbound Planning',
    auth: ['LP_Admin', 'LP_TLP'],
  },
  {
    name: 'Forecast Analytics',
    url: 'https://app.powerbi.com/groups/me/reports/acf10442-9532-461a-a857-ed12478fef5f/ReportSection703c3b5ede4ea3d7a4a5?experience=power-bi&clientSideAuth=0',
    image: '/resources/ForecastAnalytics.jpg',
    product: 'Outbound Planning',
    auth: ['LP_Admin'],
  },
  {
    name: 'OBL Dashboard',
    url: 'https://app.powerbi.com/groups/me/reports/2bbff5dc-c5e5-4f2d-ad7f-592b0db3d651/ReportSectionefad36aeae088a51036d?experience=power-bi&clientSideAuth=0',
    image: '/resources/OBL_Dashboard.jpg',
    product: 'Problem Identification',
    auth: ['LP_Admin', 'LP_OBLDashboard'],
  },
  {
    name: 'LDL Management',
    url: 'https://app.powerbi.com/reportEmbed?reportId=307d6c04-0c17-44d6-aecf-603357974486&autoAuth=true&ctid=9652d7c2-1ccf-4940-8151-4a92bd474ed0',
    image: '/resources/ldl_management.jpg',
    product: 'Problem Identification',
    auth: ['LP_Admin', 'LP_OBLDashboard'],
  },
  {
    name: 'Q.Dome',
    url: 'https://www.qdome.info/Account/Login?ReturnUrl=%2F',
    image: '/resources/qdome.png',
    product: 'Problem Identification',
    auth: ['LP_Admin', 'LP_OBLDashboard'],
  },
  {
    name: 'Shippeo',
    url: 'http://web.shippeo.com/auth/sso/mercedes-benz',
    image: '/resources/SHIPPEO_LOGO.jpg',
    product: 'Problem Identification',
    auth: ['LP_Admin', 'LP_OBLDashboard'],
  },
  {
    name: 'UBM',
    url: 'https://app.powerbi.com/groups/me/apps/e674eb89-421c-4ec8-a28a-636842a9dc65/reports/e48e07e3-3fea-4298-b710-b9608b992132?language=en-EN&experience=power-bi&bookmarkGuid=Bookmarke7720ecb161942561ee3',
    image: '/resources/Unblock_Management.jpg',
    product: 'UBM',
    auth: ['LP_Admin', 'LP_UBM'],
  },
  {
    name: 'Cost Allocation',
    url: 'https://ems.mercedes-benz.celonis.cloud/package-manager/ui/views/ui/spaces/41af6769-1d24-4fbd-93ea-6774fe8c4fe3/packages/3742675e-db81-4f51-ba99-3d0b02e39193/nodes/527b8759-bf42-4dd5-8050-53e592380a32',
    image: '/resources/cost_allocation.jpg',
    product: 'Celonis',
    auth: ['LP_Admin'],
  },
  /*   {
    name: "Bestandsoffensive",
    url: "https://ems.mercedes-benz.celonis.cloud/package-manager/ui/views/ui/spaces/41af6769-1d24-4fbd-93ea-6774fe8c4fe3/packages/8dd2e530-d8d9-4c82-9275-6fb60e2b8054/nodes/83ac7e31-ebe4-45cf-af8c-067f3315498c?activeTabs=bestandsoffensive-2025-04-10:eeeba717-9c24-4d19-9db7-56a593dc23fd",
    image: "/resources/bestandsoffensive.png",
    product: "Celonis",
    auth: ["LP_Admin"],
  }, */
  {
    name: 'Bestandsforecast BHV',
    url: 'https://ems.mercedes-benz.celonis.cloud/package-manager/ui/views/ui/spaces/41af6769-1d24-4fbd-93ea-6774fe8c4fe3/packages/3742675e-db81-4f51-ba99-3d0b02e39193/nodes/97490354-56af-4489-b38f-9ae60765cead',
    image: '/resources/bestandsoffensive_brv.jpg',
    product: 'Celonis',
    auth: ['LP_Admin'],
  },
  {
    name: 'One Lead Time Tracking',
    url: 'https://ems.mercedes-benz.celonis.cloud/package-manager/ui/views/ui/spaces/41af6769-1d24-4fbd-93ea-6774fe8c4fe3/packages/8dd2e530-d8d9-4c82-9275-6fb60e2b8054/nodes/e47c798b-fa39-4537-a513-ee58ceb4a716?activeTabs=oneleadtimetracking-v1-1-prod-2024-04-10:356ef79f-7ba9-40d3-af12-a56335a051dd',
    image: '/resources/oltt.jpg',
    product: 'Celonis',
    auth: ['LP_Admin'],
  },
  {
    name: 'Newtron',
    url: 'https://www.newtron.net/web/nmarkets/25?WEB0q09q1w7j2tcmI2I2I00I1kI0.y#A',
    image: '/resources/newtron.jpg',
    product: 'Newtron',
    auth: ['LP_Admin'],
  },
];

AppConfig.pages = [
  {
    name: 'Home',
    component: <HomePage pages={AppConfig.homeSubPages} />,
    sideBarIcon: <HomeIcon />,
    url: 'home',
  },
  {
    name: 'Settings',
    component: <SettingsPage />,
    sideBarIcon: <SettingsOutlinedIcon />,
    url: 'settings',
    auth: [
      'LP_Admin',
      'LP_Basic',
      'LP_Management',
      'DP_Vessel_Journal_Key_User',
      'DP_Vessel_Journal_Port_Operator',
      'DP_Vessel_Journal_Market_User',
      'DP_Vessel_Journal_Shipping_Company',
    ],
  },
];

export { AppConfig };
